/**
 * Dependency-free Field Activity Claim quantity normalization and math.
 * Keep the canonical equation here so both UI-heavy and model-only callers
 * share identical null and empty-string behavior.
 */

function parseFiniteClaimNumber(value: number | string | null | undefined): number | null {
    if (value == null) return null;
    const num = typeof value === 'string' ? Number(value.trim()) : Number(value);
    return Number.isFinite(num) ? num : null;
}

export function coalesceFAQuantity(
    quantity: number | string | null | undefined,
    takeOffQuantity: number | string | null | undefined
): number {
    const quantityNum = parseFiniteClaimNumber(quantity);
    if (quantityNum != null) return quantityNum;
    const takeOffNum = parseFiniteClaimNumber(takeOffQuantity);
    return takeOffNum ?? 0;
}

export function coalesceFAPercent(
    percent: number | string | null | undefined
): number {
    const percentNum = parseFiniteClaimNumber(percent);
    return percentNum ?? 1;
}

export function computeFAClaimedQuantity(
    quantity: number | string | null | undefined,
    percent: number | string | null | undefined,
    takeOffQuantity: number | string | null | undefined
): number {
    return coalesceFAQuantity(quantity, takeOffQuantity) * coalesceFAPercent(percent);
}
